import { useTranslation } from 'react-i18next';
import { 
  MapPin, 
  Phone, 
  Envelope, 
  Clock, 
  FacebookLogo, 
  InstagramLogo, 
  TwitterLogo,
  Heart
} from '@phosphor-icons/react';

// Footer Component
export const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Brand Section */}
        <div className="footer-section brand-section">
          <h3 className="footer-brand">
            <span style={{ fontSize: '2.5rem', marginRight: '0.5rem' }}>🍷</span>
            PasLaSAQ
          </h3>
          <p className="footer-description">
            Découvrez notre sélection exceptionnelle de vins, cépages et régions dans votre succursale.
          </p>
          <div className="footer-social">
            <a href="#" className="social-link" aria-label="Facebook">
              <FacebookLogo size={20} />
            </a>
            <a href="#" className="social-link" aria-label="Instagram">
              <InstagramLogo size={20} />
            </a>
            <a href="#" className="social-link" aria-label="Twitter">
              <TwitterLogo size={20} />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h4 className="footer-title">Liens rapides</h4>
          <ul className="footer-links">
            <li><a href="/">Accueil</a></li>
            <li><a href="/search">Recherche</a></li>
            <li><a href="/categories">Catégories</a></li>
            <li>
              <a 
                href="https://trello.com/invite/b/685593405a492252fbbc27e9/ATTI0d210a03ab9d7e358d19d1dc05331f22C097D137/pas-la-saq" 
                target="_blank" 
                rel="noopener noreferrer"
                className="collaborate-link"
              >
                Collaborez 💡
              </a>
            </li>
          </ul>
        </div>

        {/* Categories */}
        <div className="footer-section">
          <h4 className="footer-title">Catégories</h4>
          <ul className="footer-links">
            <li><a href="/category/rouge">Vins rouges</a></li>
            <li><a href="/category/blanc">Vins blancs</a></li>
            <li><a href="/category/rose">Vins rosés</a></li>
            <li><a href="/category/champagne">Champagne</a></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-section">
          <h4 className="footer-title">Contact</h4>
          <div className="contact-info">
            <div className="contact-item">
              <MapPin size={16} />
              <span>Stoneham, QC, Canada</span>
            </div>
            <div className="contact-item">
              <Phone size={16} />
              <span>581-777-5686</span>
            </div>
            <div className="contact-item">
              <Envelope size={16} />
              <span>thegminero@gmail.com</span>
            </div>
            <div className="contact-item">
              <Clock size={16} />
              <span>Lun-Ven 9h-18h</span>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p className="copyright">
            © {currentYear} PasLaSAQ. Tous droits réservés.
          </p>
          <p className="made-with">
            Fait avec <Heart size={14} weight="fill" /> au Québec
          </p>
        </div>
      </div>
    </footer>
  );
}; 